import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TooltipProvider } from './components/TooltipProvider';
import './App.css';

const LoginPage = lazy(() => import('./components/LoginPage'));
const LandingPage = lazy(() => import('./components/LandingPage'));
const FaceSwapPage = lazy(() => import('./components/FaceSwapPage'));
const ImageToVideoPage = lazy(() => import('./components/ImageToVideoPage'));
const ImageToImagePage = lazy(() => import('./components/ImageToImagePage'));
const AIStylistPage = lazy(() => import('./components/AIStylistPage'));
const PricingPage = lazy(() => import('./components/PricingPage'));
const SettingsPage = lazy(() => import('./components/SettingsPage'));
const PrivacyPolicyPage = lazy(() => import('./components/PrivacyPolicyPage'));
const TermsOfUsePage = lazy(() => import('./components/TermsOfUsePage'));
const CookieNoticePage = lazy(() => import('./components/CookieNoticePage'));
const BlogPage = lazy(() => import('./components/BlogPage'));
const BlogPostPage = lazy(() => import('./components/BlogPostPage'));
const ReleaseNotesPage = lazy(() => import('./components/ReleaseNotesPage'));

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <TooltipProvider>
          <Router>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/face-swap" element={<FaceSwapPage />} />
                <Route path="/faceswap" element={<FaceSwapPage />} />
                <Route path="/image-to-video" element={<ImageToVideoPage />} />
                <Route path="/image2video" element={<ImageToVideoPage />} />
                <Route path="/video-gen" element={<ImageToVideoPage />} />
                <Route path="/image-to-image" element={<ImageToImagePage />} />
                <Route path="/image2image" element={<ImageToImagePage />} />
                <Route path="/img-gen" element={<ImageToImagePage />} />
                <Route path="/ai-stylist" element={<AIStylistPage />} />
                <Route path="/app/ai-stylist" element={<AIStylistPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfUsePage />} />
                <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                <Route path="/terms-of-use-agreement" element={<TermsOfUsePage />} />
                <Route path="/cookie-notice" element={<CookieNoticePage />} />
                <Route path="/cookies" element={<CookieNoticePage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/release-notes" element={<ReleaseNotesPage />} />
                <Route path="/release-notes/:slug" element={<ReleaseNotesPage />} />
                <Route path="/release-note" element={<ReleaseNotesPage />} />
                <Route path="/release-note/:slug" element={<ReleaseNotesPage />} />
                <Route path="/release_note" element={<ReleaseNotesPage />} />
                <Route path="/release_note/:slug" element={<ReleaseNotesPage />} />
              </Routes>
            </Suspense>
          </Router>
        </TooltipProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
